module.exports = __webpack_public_path__ + "static/img/cancel.067aae84.svg";